// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"sK-z","loadingMedia":"tK-z","reviewsImagesAndVideos":"uK-z","limitHeight":"vK-z"};